import 'sumoselect';
import 'sumoselect/sumoselect.css';
import $ from 'jquery';


    document.addEventListener('DOMContentLoaded', function () {
        const markaSelect = document.getElementById('marka');
        const modelSelect = document.getElementById('model');
        const selectInputs = document.querySelectorAll('.select-input-filter');
        const sidebarForm = document.querySelector('.cars_offer--sidebar--form');
        const removeFilters = document.querySelector('.cars_offer--sidebar--bottom--remove-filters');
        const modelSumoSelect = $('#model');
        const hiddenInputs = sidebarForm.querySelectorAll('input[type="hidden"]');





        function createQueryStringFromSession() {
            const params = new URLSearchParams();

            const markaSessions = sessionStorage.getItem('selectedMarka');
            const modelSessions = JSON.parse(sessionStorage.getItem('selectedModels') || '[]');
            // MARKA
            if (markaSessions) {
                if (markaSessions && markaSessions !== '0') {
                    params.append('marka', markaSessions);
                }
            }
            // MODEL
            if (modelSessions.length > 0) {
                if (modelSessions.length > 0) {
                    // params.append('model', modelSessions.join(','));
                    modelSessions.forEach(modelId => {
                        params.append('model[]', modelId);
                    });
                }
            }

            selectInputs.forEach(select => {
                let value = sessionStorage.getItem(select.id);
                if (value && value !== '' && value !== '0') {
                    params.append(select.id, value);
                }
            });

            // Dodaj sort parametar ako postoji u sesiji
            const sortValue = sessionStorage.getItem('sort');
            if (sortValue && sortValue !== '') {
                params.append('sort', sortValue);
            }

            return params.toString();

        }

        function updateMenuLinks() {
            const queryString = createQueryStringFromSession();
            const baseUrl = '/pretraga';
            const baseUrlFirst = '/ponuda';
            const finalUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;

            const menuItem = document.getElementById('ponuda_menu_item');
            const menuItemMobile = document.getElementById('ponuda_menu_item_mobile');
            if (queryString){
                menuItem.href = finalUrl;
                menuItemMobile.href = finalUrl;
            }else{
                menuItem.href = baseUrlFirst;
                menuItemMobile.href = baseUrlFirst;
            }
        }

        updateMenuLinks()




        hiddenInputs.forEach(input => {
           if (input.value === '') {
               input.disabled = true;
           }else{
               input.disabled = false;
           }
        });



        if ($) {
            if (!modelSumoSelect[0].sumo) {
                modelSumoSelect.SumoSelect({
                    placeholder: 'Model',
                    search: true,
                    searchText: 'Pretraga...',
                    selectAll: true,
                    okCancelInMulti: false,
                    noMatch: 'Nema rezultata',
                    locale: ['OK', 'Otkaži', 'Odaberi sve/Poništi'],
                    csvDispCount: 3,
                    // captionFormat: 'Odabrano: {0}', // 3+ stavki = Odabrano: n
                    captionFormatAllSelected: 'Odabrano: {0}',
                    forceCustomRendering: true,
                });
                if (sidebarForm) {
                    sidebarForm.style.opacity = '1';
                }
            }
        }


        const sumo = modelSumoSelect[0].sumo;
        const savedModels = JSON.parse(sessionStorage.getItem('selectedModels') || '[]');
        const savedMarka = sessionStorage.getItem('selectedMarka');
        if (savedModels.length > 0) {
            sumo.selectItem(savedModels);
        }



        modelSumoSelect.on('change', function () {
            const selectedValues = $(this).val() || [];
            sessionStorage.setItem('selectedModels', JSON.stringify(selectedValues));
            updateMenuLinks()
        });

        const allFilters = markaSelect.querySelector('#all_marks_filter')

        allFilters.addEventListener('click', function () {
            modelSelect.innerHTML = '<option value="" selected disabled>Model</option>';
            modelSelect.disabled = true;
            modelSumoSelect[0].sumo.reload();
        })

        const markaDiv = markaSelect.parentElement;
        const markaTag = markaDiv.querySelector('.selected-tag');
        const markaTagText = markaDiv.querySelector('.tag-text');
        const markaHiddenInput = markaDiv.querySelector('input[type="hidden"]');
        if(!savedMarka){
            markaHiddenInput.value = '';
            markaHiddenInput.disabled = true;
            modelSelect.innerHTML = '<option value="" selected disabled>Model</option>';
            modelSelect.disabled = true;
            modelSumoSelect[0].sumo.reload();
        }
        else if (savedMarka && savedMarka !== '0') {
            let option = [...markaSelect.options].find(opt => opt.value === savedMarka);
            markaTagText.textContent = option.text;
            markaTag.style.display = 'inline-flex';
            markaDiv.style.paddingBottom = '10px';
            markaHiddenInput.value = savedMarka;
            loadModels(savedMarka, savedModels);
        }else if (markaHiddenInput.value && markaHiddenInput.value !== '0') {
            loadModels(markaHiddenInput.value, savedModels);
        }

        markaSelect.addEventListener('change', function () {
            const markaId = this.value;
            sessionStorage.setItem('selectedMarka', markaId);
            sessionStorage.removeItem('selectedModels');
            updateMenuLinks()

            if (markaId && markaId !== '0') {
                loadModels(markaId, []);
            }
        });

        modelSelect.addEventListener('change', function () {
            const selectedValues = Array.from(modelSelect.selectedOptions).map(o => String(o.value));
            sessionStorage.setItem('selectedModels', JSON.stringify(selectedValues));
        });



        selectInputs.forEach(select => {
            const div = select.parentElement
            const tag = div.querySelector('.selected-tag');
            const tagText = div.querySelector('.tag-text');
            const removeBtn = div.querySelector('.remove-tag');
            const hiddenInput = div.querySelector('input[type="hidden"]');
            const modelSelect = document.getElementById('model');
            select.addEventListener('change', () => {
                if (select.id != 'marka'){
                    sessionStorage.setItem(select.id, select.value);
                }
                updateMenuLinks();
                const value = select.value;
                const selectedOption = select.options[select.selectedIndex];
                if (value && value !== '') {
                    if (hiddenInput) {
                        hiddenInput.value = value;
                        hiddenInput.disabled = false;
                    }

                    tagText.textContent = selectedOption.text;
                    tag.style.display = 'inline-flex';
                    div.style.paddingBottom = '10px';

                    requestAnimationFrame(() => {
                        select.selectedIndex = 0;
                    });
                } else {
                    if (hiddenInput) {
                        hiddenInput.value = '';
                        hiddenInput.disabled = true;
                    }
                    tag.style.display = 'none';
                    div.style.paddingBottom = '0';
                }
            });

            select.addEventListener('focus', () => {
                if (modelSelect.parentElement.classList.contains('open')) {
                    modelSelect.parentElement.classList.remove('open');
                    modelSelect.parentElement.ariaExpanded = 'false';
                }
            });

            removeBtn.addEventListener('click', () => {
                if(removeBtn.parentElement.previousElementSibling.previousElementSibling.id === 'marka') {
                    modelSelect.innerHTML = '<option value="" selected disabled>Model</option>';
                    modelSelect.disabled = true;
                    modelSumoSelect[0].sumo.reload();
                    sessionStorage.removeItem('selectedModels');
                    sessionStorage.removeItem('selectedMarka');
                    markaHiddenInput.value = '';
                    markaHiddenInput.disabled = true;
                }
                select.selectedIndex = 0;
                tag.style.display = 'none';
                select.parentElement.style.paddingBottom = '0';
                hiddenInput.value = '';
                hiddenInput.disabled = true;
                sessionStorage.removeItem(select.id);
                updateMenuLinks();
            });
        });





        function loadModels(markaId, preselectModelIds = []) {
            modelSelect.innerHTML = '<option value="" disabled>Učitavam...</option>';
            modelSelect.disabled = true;

            fetch(`/vehicles/models/${markaId}`)
                .then(r => r.json())
                .then(data => {
                    if (!data.success) throw new Error(data.message || 'Greška pri učitavanju modela');

                    // isprazni select i dodaj opcije
                    modelSelect.innerHTML = '';

                    const preselectedSet = new Set((preselectModelIds || []).map(String));

                    data.data.forEach(m => {
                        const opt = document.createElement('option');
                        opt.value = String(m.id);
                        opt.textContent = m.title;
                        if (preselectedSet.has(String(m.id))) opt.selected = true;
                        modelSelect.appendChild(opt);
                    });

                    modelSelect.disabled = false;
                    // Inicijalizuj ili reload-uj SumoSelect POSLE što si dodao opcije
                    if ($) {
                        const el = $('#model')[0];
                        if (el && el.sumo) {
                            el.sumo.reload(); // osveži listu
                        } else {
                            modelSumoSelect.SumoSelect({
                                placeholder: 'Model',
                                search: true,
                                searchText: 'Pretraga...',
                                selectAll: true,
                                captionFormatAllSelected: 'Označi sve',
                                okCancelInMulti: false,
                                noMatch: 'Nema rezultata',
                                locale: ['OK', 'Otkaži', 'Odaberi sve/Poništi'],
                                csvDispCount: 2, // 1-2 naziva, zatim "+n" (Sumo-ov default prikaz)
                            });
                        }
                    }
                })
                .catch(err => {
                    console.error('Greška:', err);
                    modelSelect.innerHTML = '<option value="" disabled>Greška pri učitavanju</option>';
                    // Ako je već postojao Sumo, samo reload da prikaže poruku
                    if ($) {
                        const el = $('#model')[0];
                        if (el && el.sumo) el.sumo.reload();
                    }
                });
        }


        // Reset svih polja
        if (removeFilters) {
            removeFilters.addEventListener('click', function () {
                selectInputs.forEach(select => {
                    const div = select.parentElement
                    const tag = div.querySelector('.selected-tag');
                    const tagText = div.querySelector('.tag-text');
                    const hidden = div.querySelector('input[type="hidden"]');
                    sessionStorage.removeItem(select.id, select.value);
                    tagText.textContent = '';
                    tag.style.display = 'none';
                    div.style.paddingBottom = '0';
                    select.selectedIndex = 0;
                    if (hidden) {
                        hidden.value = '';
                        hidden.disabled = true;
                    }
                });

                sessionStorage.removeItem('selectedMarka');
                sessionStorage.removeItem('selectedModels');
                sessionStorage.removeItem('sort');
                const menuItem = document.getElementById('ponuda_menu_item');
                const menuItemMobile = document.getElementById('ponuda_menu_item_mobile');
                menuItem.href = '/ponuda';
                menuItemMobile.href = '/ponuda';

                markaSelect.selectedIndex = 0;
                modelSelect.innerHTML = '<option value="" selected disabled>Model</option>';
                modelSelect.disabled = true;
                modelSumoSelect[0].sumo.reload();

                window.location.href = '/ponuda';
            });
        }

    // });


    // const selectInputsAll = document.querySelectorAll('.select-input-filter');
    // document.addEventListener("DOMContentLoaded", () => {
        selectInputs.forEach(select => {
            const div = select.parentElement
            const tag = div.querySelector('.selected-tag');
            const tagText = div.querySelector('.tag-text');
            const selectValue =  sessionStorage.getItem(select.id);
            if (selectValue && selectValue !== '0') {
                const optionToSelect = Array.from(select.options).find(option => option.value === selectValue);
                select.nextElementSibling.value = selectValue;
                select.nextElementSibling.disabled = false;
                if (optionToSelect) {
                    tagText.textContent = optionToSelect.text;
                    tag.style.display = 'inline-flex';
                    div.style.paddingBottom = '10px';
                    select.selectedIndex = 0;
                }
            }
        });
        updateMenuLinks()
    // });
// }
    });
